import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HealthyComponent } from './healthy.component';

const routes: Routes = [{ path: '', component: HealthyComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HealthyRoutingModule {}
